// extracted by mini-css-extract-plugin
module.exports = {"container":"BirthRecords_container__KcVys","row":"BirthRecords_row__1pwr6","attrCell":"BirthRecords_attrCell__3GE8f","column":"BirthRecords_column__1stS0"};